export default __webpack_public_path__ + "static/media/mission.192adc34.jpg";